/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { ICloud } from 'generated-types';

export interface IInfraCloudState {
    cloud: ICloud | null;
    isLoading: boolean;
    error: any;
}

export const initialInfraCloudState: IInfraCloudState = {
    cloud: null,
    isLoading: false,
    error: null,
};
